import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
//import { ToastrService } from 'ngx-toastr';
import { IssueDetailModel, IssueModel, IssueTrackModel } from 'src/app/shared/models/issue.model';
import { IssueTrackService } from 'src/app/shared/services/issue-track.service';
import { GlobalNotification} from "src/app/shared/constants/global-notification";

@Component({
  selector: 'app-issue-track-edit',
  templateUrl: './issue-track-edit.component.html',
  styleUrls: ['./issue-track-edit.component.css']
})
export class IssueTrackEditComponent implements OnInit {
  @Input() issue : IssueDetailModel;
  form : FormGroup = IssueTrackModel.getFormGroup();

  constructor(
    private service : IssueTrackService,
    //private toastr : ToastrService
    private gnotify : GlobalNotification
  ) { }

  ngOnInit() {
    IssueTrackModel.initializeFormGroup(this.form, this.issue.issueId);
  }

  onSave()
  {
    console.log("onSave : " + this.form.get('issueId').value);
    if(!this.form.get('trackId').value)
    {
      this.service.insertData(this.form.value).subscribe(
        res=>{
          ////this.toastr.success("Submit successfuly", "Issue Create");
          this.gnotify.showSnackBar('Issue Create', 'Submit successfuly', "success");
        },
        err=>{
          console.log(err);
          ////this.toastr.error("Failed to Submit", "Issue Create");
          this.gnotify.showSnackBar('Issue Create', 'Failed to Submit', "error");
        }
        );
    }

  }

  onDelete()
  {

  }

}
